import React, { useState, useEffect } from "react";
import axios from "axios";
import Swal from "sweetalert2"; // 1. Import SweetAlert2
import { 
  BiUser, BiMailSend, BiPhone, BiMap, BiArrowBack, BiSave, BiSolidUserCircle 
} from "react-icons/bi";

import { HiOutlineUser, HiOutlineWallet, HiOutlineTicket, HiOutlineSparkles } from "react-icons/hi2";

import { 
  CountrySelect, StateSelect, CitySelect 
} from "react-country-state-city";
import "react-country-state-city/dist/react-country-state-city.css";

import { baseurl } from "../../baseurl";
import "../../asset/css/profile.css";
import { Link } from "react-router-dom";
import { useNavigate } from "react-router-dom";

const Profile = () => {
  const [userData, setUserData] = useState(null);
  const [loading, setLoading] = useState(true);
  const [updating, setUpdating] = useState(false);
  const [countryid, setCountryid] = useState(0);
  const [stateid, setStateid] = useState(0);

  const [formData, setFormData] = useState({
    name: "", phone: "", gender: "", address_line1: "",
    pincode: "", city: "", state: "", country: ""
  });

  const guestUserId = localStorage.getItem("guestUserId");

  // 2. Define the Toast Mixin
  const Toast = Swal.mixin({
    toast: true,
    position: 'top-end',
    showConfirmButton: false,
    timer: 3000,
    timerProgressBar: true,
    didOpen: (toast) => {
      toast.addEventListener('mouseenter', Swal.stopTimer)
      toast.addEventListener('mouseleave', Swal.resumeTimer)
    }
  });

  useEffect(() => {
    const fetchProfileData = async () => {
      try {
        const res = await axios.get(`${baseurl}/getGuestUserDetails/${guestUserId}`);
        const user = res.data.user;
        setUserData(user);
        setFormData({
          name: user.name || "",
          phone: user.phone || "",
          gender: user.gender || "Male",
          address_line1: user.address_line1 || "",
          pincode: user.pincode || "",
          city: user.city || "",
          state: user.state || "",
          country: user.country || ""
        });
      } catch (err) {
        console.error("Error fetching profile:", err);
      } finally {
        setLoading(false);
      }
    };
    if (guestUserId) fetchProfileData();
  }, [guestUserId]);

  // 3. Updated Update API Call with Toast
  const handleUpdateProfile = async () => {
    // Construct the payload to match what axios is sending
    const payload = {
        guestUserId,
        ...formData
    };

    // --- LOGS START ---
    console.log("🚀 Attempting to update profile...");
    console.log("📍 Target URL:", `${baseurl}/updateGuestUserProfile`);
    console.log("📦 Data Sent to Backend:", payload);
    // --- LOGS END ---

    setUpdating(true);
    try {
      const res = await axios.post(`${baseurl}/updateGuestUserProfile`, payload);
      
      console.log("✅ Server Response:", res.data);

      if (res.data.status === "success") {
        Toast.fire({
          icon: 'success',
          title: 'Profile updated successfully'
        });
        setUserData(res.data.user);
      }
    } catch (err) {
      // Log detailed error information
      console.error("❌ Update Error Details:", err.response?.data || err.message);
      
      Toast.fire({
        icon: 'error',
        title: err.response?.data?.message || 'Failed to update profile'
      });
    } finally {
      setUpdating(false);
    }
};

const navigate = useNavigate();
  const handleLogout = () => { 
  localStorage.clear(); 
  navigate("/"); 
  window.location.reload(); 
  };

  if (loading) return <div className="loader-container"><div className="spinner-border text-teal"></div></div>;

  return (
    <section className="profile-page py-5">
      <div className="container">



 
<div className="mobile-nav-wrapper mb-3">
  <div className="mobile-nav-container">
    <Link to="/profile" className="mobile-nav-link">
      <HiOutlineUser className="nav-icon" />
      <span>Profile</span>
    </Link>
    <Link to="/wallet" className="mobile-nav-link">
      <HiOutlineWallet className="nav-icon" />
      <span>Pocket</span>
    </Link>
    <Link to="/booking" className="mobile-nav-link">
      <HiOutlineTicket className="nav-icon" />
      <span>Bookings</span>
    </Link>
    {/* Add more links here to see the sliding effect */}
    <Link  className="mobile-nav-link" onClick={handleLogout}>
      <HiOutlineSparkles className="nav-icon" />
      <span>Logout</span>
    </Link>
  </div>
</div>
<style>
  {`
  /* Hide wrapper on Desktop */
.mobile-nav-wrapper {
  display: none;
}

@media (max-width: 768px) {
  .mobile-nav-wrapper {
    display: block;
    width: 100%;
    background: rgba(255, 255, 255, 0.8);
    backdrop-filter: blur(10px); /* Glassmorphism effect */
    border-bottom: 1px solid rgba(0, 0, 0, 0.05);
    position: sticky;
    top: 0;
    z-index: 1000;
  }

  .mobile-nav-container {
    display: flex;
    overflow-x: auto; /* Enables sliding */
    scroll-behavior: smooth;
    -webkit-overflow-scrolling: touch;
    padding: 12px 10px;
    gap: 15px;
  }

  /* Hide scrollbar for Chrome, Safari and Opera */
  .mobile-nav-container::-webkit-scrollbar {
    display: none;
  }

  /* Hide scrollbar for IE, Edge and Firefox */
  .mobile-nav-container {
    -ms-overflow-style: none;  
    scrollbar-width: none;  
  }

  .mobile-nav-link {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    min-width: 80px; /* Ensures enough width for sliding */
    text-decoration: none;
    color: #64748b; /* Slate gray */
    transition: all 0.3s ease;
    flex-shrink: 0; /* Prevents links from squishing */
  }

  .nav-icon {
    font-size: 20px;
    margin-bottom: 4px;
    padding: 0px;
    background: #f1f5f9;
    border-radius: 12px;
    transition: all 0.3s ease;
  }

  .mobile-nav-link span {
    font-size: 11px;
    font-weight: 600;
    text-transform: uppercase;
    letter-spacing: 0.5px;
  }

  /* Active/Hover State */
  .mobile-nav-link:hover, .mobile-nav-link:focus {
    color: #166070;
  }

  .mobile-nav-link:hover .nav-icon {
    background: #166070;
    color: #ffffff;
    transform: translateY(-2px);
  }
}
`}
</style>


        <div className="d-flex align-items-center mb-4">
          <button className="back-btn me-3" onClick={() => window.history.back()}>
            <BiArrowBack />
          </button>
          <h3 className="fw-bold m-0 text-dark">Account Settings</h3>
        </div>

        <div className="row justify-content-center">
          <div className="col-lg-10">
            <div className="profile-card p-4 p-md-5 bg-white rounded-4 shadow-sm border-0">
              
              <div className="text-center mb-5">
                <div className="avatar-circle mx-auto mb-3">
                  {formData.name ? formData.name.charAt(0).toUpperCase() : <BiSolidUserCircle />}
                </div>
                <h4 className="fw-bold mb-1">{userData?.name}</h4>
                <p className="text-muted small">Guest User #{guestUserId}</p>
              </div>

              <div className="row g-4">
                <h5 className="fw-bold text-primary-color mb-2">Personal Information</h5>
                
                <div className="col-md-6">
                  <label className="form-label small fw-bold">Full Name</label>
                  <div className="input-group">
                    <span className="input-group-text"><BiUser /></span>
                    <input 
                      type="text" 
                      className="form-control" 
                      value={formData.name} 
                      onChange={(e) => setFormData({...formData, name: e.target.value})}
                      placeholder="Enter your name" 
                    />
                  </div>
                </div>

                <div className="col-md-6">
                  <label className="form-label small fw-bold">Email Address</label>
                  <div className="input-group">
                    <span className="input-group-text"><BiMailSend /></span>
                    <input type="email" className="form-control" value={userData?.email} readOnly disabled />
                  </div>
                </div>

                <div className="col-md-6">
                  <label className="form-label small fw-bold">Phone Number</label>
                  <div className="input-group">
                    <span className="input-group-text"><BiPhone /></span>
                    <input 
                      type="text" 
                      className="form-control" 
                      value={formData.phone} 
                      onChange={(e) => setFormData({...formData, phone: e.target.value})}
                      placeholder="Phone number" 
                    />
                  </div>
                </div>

                <div className="col-md-6">
                  <label className="form-label small fw-bold">Gender</label>
                  <select 
                    className="form-select form-control" 
                    value={formData.gender}
                    onChange={(e) => setFormData({...formData, gender: e.target.value})}
                  >
                    <option value="Male">Male</option>
                    <option value="Female">Female</option>
                    <option value="Other">Other</option>
                  </select>
                </div>

                <hr className="my-4 text-muted opacity-25" />
                <h5 className="fw-bold text-primary-color mb-2">Location Details</h5>

               <div className="col-md-4">
  <label className="form-label small fw-bold">Country</label>
  <CountrySelect
    onChange={(e) => {
      setCountryid(e.id);
      setFormData({ ...formData, country: e.name, state: "", city: "" });
    }}
    // This shows the saved value inside the input box if it exists
    defaultValue={formData.country ? { name: formData.country, id: countryid } : null}
    placeHolder="Select Country"
    inputClassName="form-control"
  />
</div>

<div className="col-md-4">
  <label className="form-label small fw-bold">State</label>
  <StateSelect
    countryid={countryid}
    onChange={(e) => {
      setStateid(e.id);
      setFormData({ ...formData, state: e.name, city: "" });
    }}
    // Shows saved state inside the box
    defaultValue={formData.state ? { name: formData.state, id: stateid } : null}
    placeHolder="Select State"
    inputClassName="form-control"
  />
</div>

<div className="col-md-4">
  <label className="form-label small fw-bold">City</label>
  <CitySelect
    countryid={countryid}
    stateid={stateid}
    onChange={(e) => {
      setFormData({ ...formData, city: e.name });
    }}
    // Shows saved city inside the box
    defaultValue={formData.city ? { name: formData.city } : null}
    placeHolder="Select City"
    inputClassName="form-control"
  />
</div>

                <div className="col-md-8">
                  <label className="form-label small fw-bold">Address Line 1</label>
                  <input 
                    type="text" 
                    className="form-control" 
                    value={formData.address_line1} 
                    onChange={(e) => setFormData({...formData, address_line1: e.target.value})}
                    placeholder="Street address, P.O. box" 
                  />
                </div>

                <div className="col-md-4">
                  <label className="form-label small fw-bold">Pin Code</label>
                  <input 
                    type="text" 
                    className="form-control" 
                    value={formData.pincode} 
                    onChange={(e) => setFormData({...formData, pincode: e.target.value})}
                    placeholder="Zip code" 
                  />
                </div>

                <div className="col-12 mt-5">
                  <button 
                    className="btn btn-primary w-100 py-3 fw-bold d-flex align-items-center justify-content-center gap-2 shadow"
                    onClick={handleUpdateProfile}
                    disabled={updating}
                  >
                    <BiSave size={20} /> 
                    {updating ? "Saving Changes..." : "Save Profile Changes"}
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Profile;